<div class="has-navbar-vertical-aside navbar-vertical-aside-show-xl footer-offset" [class.navbar-vertical-aside-mini-mode]="sidebarCollapsed">
  <header id="header" class="navbar navbar-expand-lg navbar-fixed navbar-height navbar-container navbar-bordered bg-white">
  <app-topbar></app-topbar>
  </header>

  <main class="main">

    <div class="content container-fluid">
      <sidebar [(sidebarCollapsed)]="sidebarCollapsed"></sidebar>

      <div>
        <router-outlet></router-outlet>
      </div>

    </div>
  </main>
</div>
